import {
  CrossWorkspaceFileDropDialog,
  type CrossWorkspaceFileDropChoice,
} from "@/action-dialog/dialogs/CrossWorkspaceFileDropDialog";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type CrossWorkspaceFileDropCallableProps = {
  count: number;
  fileName?: string;
  destination: "canvas" | "chat";
};

/** Resolves with the chosen path, or null when dismissed. */
export const CrossWorkspaceFileDropCallable = createCallable<
  CrossWorkspaceFileDropCallableProps,
  CrossWorkspaceFileDropChoice | null
>(
  ({ call, count, fileName, destination }) => (
    <CrossWorkspaceFileDropDialog
      count={count}
      fileName={fileName}
      destination={destination}
      onChoose={(choice) => call.end(choice)}
      onClose={() => call.end(null)}
    />
  ),
  UNMOUNTING_DELAY_MS,
);

CrossWorkspaceFileDropCallable.displayName = "CrossWorkspaceFileDropCallable";
